// extracted by mini-css-extract-plugin
module.exports = {"select":"src-components-RegionSelect-index-module__select--1r3J-"};